import { render, staticRenderFns } from "./BQCms.vue?vue&type=template&id=25243559&scoped=true"
import script from "./BQCms.vue?vue&type=script&lang=js"
export * from "./BQCms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25243559",
  null
  
)

export default component.exports